import React, {Component} from 'react';
import '../../styles/Home.css'
import Footer from "../../shared/Footer";
import {Link, withRouter} from "react-router-dom";
import AplikacjaMobilna from "../../home/homeComponents/AplikacjaMobilna";
import {NotificationManager} from "react-notifications";

class Panel extends Component {

    constructor(props) {
        super(props);

        let linkActive = 2;

        if (this.props.link !== undefined && this.props.link !== null) {
            linkActive = this.props.link;
        }

        this.state = {
            onRegister: false,
            linkActive: linkActive,
            refresh: false,
            redirect: false,
            zmianaHasla: false
        }
    }

    componentDidMount() {
        if (this.props.notify === true) {
            NotificationManager.info("", "Najpierw uzupełnij dane osobowe wymagane do zakupu biletów miesięcznych, kontaktu z BOK i oceny przejazdu ", 5000)

        }
    }

    render() {
        return <div>

            <div className="wynajemNaglowek przerywnik no-animation">
                <div className="container text-center">
                    <h2><b>Witaj w panelu administracji kontem.</b></h2>
                    <h4>Z poziomu panelu możesz zarządzać swoimi biletami oraz danymi konta.</h4>
                </div>
            </div>
            <div style={{background: '#efefef', padding: 15}} className="panelPaddingMobilka">
                <div className="container ramka" style={{background: 'white', padding: 50, minHeight: 600}}>
                    <div className="panel row">
                        <div className="col-2 menu">
                            <h4 style={{textAlign: 'center', marginBottom: 20}}><b>Menu</b></h4>
                            <Link className="formatLink" to={'/konto/bilety'}>
                                <div className="panel-link"><i
                                    className="fa fa-ticket" style={{width: 25, textAlign: 'center'}}> </i> Moje bilety
                                </div>
                            </Link>
                            {this.state.linkActive === 2 || this.state.linkActive === 3 || this.state.linkActive === 4 ?
                                <div><Link className="formatLink" to={'/konto/bilety/jednorazowe'}>
                                    <div className="panel-link-secondary">Jednorazowe
                                    </div>
                                </Link>
                                    <Link className="formatLink" to={'/konto/bilety/miesieczne'}>
                                        <div className="panel-link-secondary">Miesięczne
                                        </div>
                                    </Link>
                                </div>
                                : null}
                            <Link className="formatLink" to={'/konto/dane'}>
                                <div className="panel-link"><i
                                    className="fa fa-id-card" style={{width: 25, textAlign: 'center'}}> </i> Dane
                                    klienta
                                </div>
                            </Link>
                            <Link className="formatLink" to={'/konto/haslo'}>
                                <div className="panel-link"><i
                                    className="fa fa-lock" style={{width: 25, textAlign: 'center'}}> </i> Zmiana
                                    hasła
                                </div>
                            </Link>
                            <Link className="formatLink" to={'/konto/eventy'}>
                                <div className="panel-link"><i
                                    className="fa fa-star" style={{width: 25, textAlign: 'center'}}> </i> Eventy
                                </div>
                            </Link>
                            <Link className="formatLink" to={'/konto/bok'}>
                                <div className="panel-link"><i
                                    className="fa fa-phone" style={{width: 25, textAlign: 'center'}}> </i> BOK
                                </div>
                            </Link>
                        </div>
                        <div className="col-10 zawartoscKontoMobilka" style={{paddingLeft: 25}}>
                            {this.props.children}
                        </div>
                    </div>
                </div>
            </div>
            {/*<AplikacjaMobilna/>*/}
            <Footer/>
        </div>
    }

}

export default withRouter(Panel)



// WEBPACK FOOTER //
// ./src/components/konto/panel/Panel.js